import {
  JobList,
  JoinCapacity,
  OtherBenefitsFlg,
  SexFlug,
} from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    contractorName: "契約者（法人）名",
    keyword: "contractorName",
    type: "contractorAndNumber",
    showLine: false,
  },
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: "基本情報",
  },
  {
    title: "氏名カナ",
    keyword: "staffNameKana",
    type: "name",
    useFurigana: true,
    hafWidth: true,
    convertToHalfwidth: true,
  },
  {
    title: "氏名",
    keyword: "staffNameKanji",
    type: "name",
    requiredIcon: true,
    firstNameDisabled: true,
  },
  {
    title: "氏名変更年月日",
    keyword: "nameChangeDate",
    type: "date",
    maxDate: new Date(),
    minDate: new Date("1900/01/01"),
  },
  {
    title: "生年月日",
    keyword: "birthday",
    type: "date",
    requiredIcon: true,
    maxDate: new Date(),
    minDate: new Date("1900/01/01"),
  },
  {
    title: "性別",
    keyword: "sex",
    type: "radio",
    requiredIcon: true,
    radioPropsList: TkGetCodeList(SexFlug),
  },
  {
    title: "加入資格",
    keyword: "joinCapacity",
    type: "radio",
    requiredIcon: true,
    radioPropsList: TkGetCodeList(JoinCapacity),
    helpicon: true,
    helpText: (
      <>
        加入資格については、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫加入要件について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
        <br />
      </>
    ),
  },
  {
    title: "職種",
    keyword: "jobList",
    type: "selectForm",
    requiredIcon: true,
    selectPropsList: TkGetCodeList(JobList),
  },
  {
    title: "福祉医療機構以外からの退職金受け取りの有無",
    keyword: "prefectureRetirementJoinFlg",
    type: "radio",
    requiredIcon: true,
    radioPropsList: TkGetCodeList(OtherBenefitsFlg),
  },
];
const schema = {
  staffNameKana: {
    pattern: {
      value: /^[ｧ-ﾝｦﾞﾟ\s-]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0054E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  staffNameKanji: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  birthday: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  sex: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  jobList: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  joinCapacity: { required: TkPropertyMessageGet("TKMSG_SCR0043E") },
  prefectureRetirementJoinFlg: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
};

export { schema, fakeTableList };
